// Colorado School of Mines majors (#2739). Read on 2026-10-01 from the
// official 2026-2027 Colorado School of Mines Catalog, Undergraduate Degree
// Information and Graduation Information, which lists every degree Mines awards
// as "Bachelor of Science (<field>)", shown here as BS; the catalog's Academic
// Programs page confirms 21 distinct Bachelor of Science degrees. The catalog
// lists them without colleges, so they are one A to Z group. Minors, ROTC, the honors programs and the combined
// undergraduate/graduate programs are left out.
const majors = {
    "slug": "colorado-school-of-mines",
    "read": "2026-10-01",
    "intro": "All 21 bachelor of science degrees in Mines' official 2026-2027 Catalog. Minors and combined undergraduate and graduate programs are left out.",
    "groups": [
        {
            "name": "Bachelor of Science degrees, A to Z",
            "source": {
                "label": "Mines Catalog 2026-2027, Undergraduate Degree Information",
                "url": "https://catalog.mines.edu/undergraduate/degreerequirementsgraduationinfo/"
            },
            "majors": [
                {
                    "name": "Applied Mathematics and Statistics",
                    "degree": "BS"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Business Engineering and Management Science",
                    "degree": "BS"
                },
                {
                    "name": "Ceramic Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Construction Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Design Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Engineering Physics",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Geological Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Geophysical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Metallurgical and Materials Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mining Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Petroleum Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Quantitative Biosciences and Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Quantum Systems Engineering",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
